import { Machine } from '../../../utils/models/Machine'
import './MachineCardAllMeasures.scss'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { AwCarousel } from 'aw-carousel'
import DataCircle from '../../DataComponent/DataCircle.component'
import { getRandomNumber } from 'aw-generic-functions'
import { isTabletScreen } from '../../../utils/const'


export interface Measurement {
    field: string;
    value: number;
    units: string;
}

export interface Alarm {
    field: string;
    active: boolean;
}


const MachineCardAllMeasures = (props: { machine: Machine, refresh: boolean }) => {

    const { t } = useTranslation()

    const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1000);
    const [switchButton, setSwitchButton] = useState("measures");

    const mesures: Measurement[] = [
        { field: '1', value: getRandomNumber(10, 50), units: 'ºC' },
        { field: '2', value: getRandomNumber(10, 100), units: '%' },
        { field: '3', value: getRandomNumber(1000, 9000), units: 'hPa' },
        { field: '4', value: getRandomNumber(10, 1000), units: 'ppm' },
        { field: '5', value: getRandomNumber(10, 100), units: '%' },
        { field: '6', value: getRandomNumber(10, 100), units: 'ºC' },
    ]

    const alarms: Alarm[] = [
        { field: 'temperature', active: true },
        { field: 'humidity', active: false },
        { field: 'pressure', active: true },
        { field: 'co2', active: false },
        { field: 'pm10', active: true },
    ]

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth > 1000);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    return (
        <>
            <div className='kpiContainer3 px-2 rounded-1 d-flex flex-column h-100'>
                <span className="mt-1 h4 text-center">{switchButton == "measures" ? t('Measures') : t('Alarmas')}</span>
                {/* <ToggleButtonGroup type="radio" name="options" className="buttonSwitch" value={switchButton} onChange={setSwitchButton}>
                    <ToggleButton id="r-measures" value={"measures"} className='btn-Blue'>
                        <i className="bi bi-activity"></i>
                    </ToggleButton>
                    <ToggleButton id="r-alarms" value={"alarms"} className='btn-Blue'>
                        <i className="bi bi-exclamation-triangle"></i>
                        { (numActiveAlarms > 0) && 
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                {numActiveAlarms}
                            </span>
                        }
                    </ToggleButton>
                </ToggleButtonGroup> */}

                {props.refresh ? <div className="text-center pt-4"><Spinner animation="border" style={{ color: 'var(--accent-color)' }} /></div> : (


                    switchButton == "measures" ?
                        // Measures
                        <div className='row my-2 gx-0 flex-grow-1 h-100'>
                            {
                                mesures ? (
                                    <AwCarousel items={mesures} rows={isTabletScreen() ? 3 : 2} cols={isTabletScreen() ? 2 : 3} activePageIndicatorColor="var(--accent-color)" colSpacing={2}>
                                        {(item: Measurement) => <DataCircle color={3} data={item.value} refresh={props.refresh} title={`${t('Measure')} ${item.field}`} units={item.units} />}
                                    </AwCarousel>

                                ) : <h5 className='text-center'>No Info</h5>
                            }
                        </div>
                        :
                        //Alarms
                        <div className='row my-2 gx-0 flex-grow-1 h-100'>
                             {
                                alarms ? (
                                    <AwCarousel items={alarms} rows={isWideScreen ? 3 : 3} cols={isWideScreen ? 3 : 3} activePageIndicatorColor="var(--accent-color)">
                                        {(item: Alarm) =>
                                            <div className="ledContainer justify-content-center rounded-1 px-1 pt-3">
                                                {props.refresh ? <div className="text-center pt-4"><Spinner animation="border" style={{ color: 'var(--accent-color)' }} /></div> :
                                                    <>
                                                        <div className={`rounded-circle ${!item.active ? 'ledStyleGreen' : 'ledStyleRed'}`} />
                                                        <span className="mt-2">{t(item.field)}</span>
                                                    </>
                                                }
                                            </div>
                                        }
                                    </AwCarousel>

                                ) : <h5 className='text-center'>No Info</h5>
                            } 
                        </div>
                )}
            </div >
        </>
    )
}

export default MachineCardAllMeasures